import { Radar, RadarChart, PolarGrid, Legend, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer } from 'recharts';

const data = [
    { language: 'React/Next.js', A: 80 },
    { language: 'Node.js ', A: 90 },
    { language: 'Golang', A: 80 },
    { language: 'Typescript', A: 90 },
    { language: 'Terraform', A: 70 },
    { language: 'AWS CDK', A: 70 },
    { language: 'Python', A: 70 },
    { language: 'SQL', A: 80 },
];

const SkillsChart = () => (
    <ResponsiveContainer height={500}>
        <RadarChart data={data}>
            <PolarGrid />
            {/*outer line with names*/}
            <PolarAngleAxis dataKey='language' tick={{ stroke: '#fff' }} />
            {/*// line showing numbers*/}
            <PolarRadiusAxis />
            <Radar name='Mike' dataKey='A' stroke='#8884d8' fill='#BEFF07' fillOpacity={0.6} />
        </RadarChart>
    </ResponsiveContainer>
);

export default SkillsChart;
